if (!customElements.get('single-product-upsell')) {
  customElements.define(
    'single-product-upsell',
    class SingleProductUpsell extends HTMLElement {
      constructor() {
        super();
        this.isSubmitting = false;
        this.onButtonClick = this.addToCart.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('.single-product-upsell__button');
        this.feedback = this.querySelector('.single-product-upsell__feedback');
        this.spinner = this.querySelector('.loading__spinner');
        this.button?.addEventListener('click', this.onButtonClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onButtonClick);
      }

      async addToCart() {
        if (this.isSubmitting || !this.button || this.button.disabled) return;

        const variantId = this.dataset.variantId;
        if (!variantId) return;

        const cartDrawer = document.querySelector('cart-drawer');
        const cartItems = document.querySelector('cart-items');
        const cartNotification = document.querySelector('cart-notification');
        const formData = new FormData();
        const sections = [];

        formData.append('id', variantId);
        formData.append('quantity', '1');

        this.setLoading(true);
        this.showFeedback('');

        try {
          if (cartDrawer) {
            await customElements.whenDefined('cart-drawer');
            cartDrawer.init();
            sections.push(...cartDrawer.getSectionsToRender().map((section) => section.id));
          }

          if (cartNotification) {
            await customElements.whenDefined('cart-notification');
            window.loadTemplateContent(cartNotification);
            cartNotification.init();
            sections.push(...cartNotification.getSectionsToRender().map((section) => section.id));
          }

          if (cartItems) {
            sections.push(...cartItems.getSectionsToRender().map((section) => section.section));
          }

          if (sections.length) {
            formData.append('sections', [...new Set(sections)]);
            formData.append('sections_url', window.location.pathname);

            if (theme.settings.cartDrawer.atcAction === 'drawer' && cartDrawer) {
              cartDrawer.setActiveElement(this.button);
            } else if (theme.settings.cartDrawer.atcAction === 'notification' && cartNotification) {
              cartNotification.setActiveElement(this.button);
            }
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const response = await fetch(`${routes.cart_add_url}`, config);
          const parsedState = await response.json();

          if (!response.ok || parsedState.status) {
            const message = parsedState.description || parsedState.message || 'Unable to add this item. Please try again.';
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'single-product-upsell',
              productVariantId: variantId,
              errors: parsedState.errors || message,
              message: parsedState.message,
            });
            this.showFeedback(message, 'error');
            if (cartDrawer) cartDrawer.reload();
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'single-product-upsell',
            productVariantId: variantId,
            cartData: parsedState,
          });

          if (cartDrawer) cartDrawer.renderContents(parsedState);
          if (cartItems) cartItems.renderContents(parsedState);
          if (cartNotification) cartNotification.renderContents(parsedState);
          cartDrawer?.classList.remove('is-empty');
          cartNotification?.classList.remove('is-empty');
          this.showFeedback('Added to your cart.', 'success');
        } catch (error) {
          console.error(error);
          const message = 'Unable to add this item. Please try again.';
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'single-product-upsell',
            productVariantId: variantId,
            errors: message,
            message,
          });
          this.showFeedback(message, 'error');
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.isSubmitting = isLoading;
        this.button.toggleAttribute('aria-disabled', isLoading);
        this.button.toggleAttribute('aria-busy', isLoading);
        this.button.classList.toggle('loading', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);
        this.spinner?.classList.toggle('spinning-complete', !isLoading);
      }

      showFeedback(message, state = '') {
        this.feedback.textContent = message;
        if (state) {
          this.feedback.dataset.state = state;
        } else {
          delete this.feedback.dataset.state;
        }
      }
    }
  );
}
